export const getRelProperty = (noFollow?: boolean, target?: string, sponsored?: boolean, referrer?: boolean) => {
  const relProperties = [];
  if (!referrer && target === '_blank') {
    relProperties.push('noopener noreferrer');
  }

  if (noFollow) {
    relProperties.push('noFollow');
  }

  if (sponsored) {
    relProperties.push('sponsored');
  }

  return relProperties.length === 0 ? undefined : relProperties.join(' ');
};

export const getReferrer = (uri?: string) => {
  if (!uri) return false;
  return uri?.startsWith('/') || uri?.includes('.rtl.de') || uri?.includes('.tvnow.de');
};
